module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch1"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('p', {
    staticClass: "centerImage"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/chap1.jpg",
      "width": "80%"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _vm._v("T"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("HE FIGURE IN THE FINE GRAY SUIT MATERIALIZED IN THE NURSERY")]), _vm._v(" and stood over the sleeping infant, inhaling the sweet, milky night air. He could have taken any form, really: a sparrow, a snowy owl, even a common housefly. Although he often traveled the world on wings, for this work he always preferred a human guise.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Standing beneath a leaded glass window, the visitor, who was known as Love, removed a small, pearl-headed pin from his tie and pricked his finger. A bead of blood rose and caught the reflection of the slice of moon that hung low in the late winter sky. He bent over the cradle and slid his bleeding fingertip into the child’s mouth. The baby, a boy, tried to suckle, his forehead wrinkling, his small hands curling into fists.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Shh,” the figure whispered. “Shh.” This player. He could not think of one he’d loved more.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("After a time, Love slipped his finger out of the boy’s mouth, satisfied that the blood had given the boy a steady heart. He replaced his pin and regarded the child. He removed a book from his pocket, scribbled a few lines, and tucked it away again. When he could stay no longer, he uttered two words, as softly as a prayer: “Have courage.”")]), _vm._v(" "), _c('p', {
    staticClass: "spaceOrnament"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/orn.jpg",
      "width": "80%"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("The next night, in a small green house across town, his opponent made her choice. In this house, there was no leaded glass in the windows. No gracious nursery, no wrought-iron crib. The child was a girl. A girl who slept in an apple crate — happily so, for she did not yet know of anything else.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("In the house’s other bedroom, the child’s grandmother slept lightly, listening from some ever-alert corner of her mind for the sounds that would indicate the child’s parents had returned home: the creak of a door, the whisper of voices, the careful pad of tiptoeing feet.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The old woman would wait forever to hear those sounds again.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Wearing a pair of soft leather gloves, Love’s opponent, known as Death, reached for the child, who woke and blinked sleepily at the unfamiliar face overhead. To Death’s relief, the baby did not cry. Instead, she looked at her with wonder. Death held a candle near so the child might have a better view. The baby blinked twice, smiled, and reached for the flame.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Pleased, Death set the candle down, held the baby close to her chest, and walked to the uncovered window, which revealed a whitened world glowing beneath a silver flannel sky. She and the baby watched the snow fall together. At last, the child fell asleep in her arms.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Death concentrated on her essential task, relieved when she at last felt the telltale pressure behind her eyes. After much effort, a single black tear gathered in her lashes. Death removed her glove with her teeth. It made hardly any noise as it hit the floor. With her index finger, Death lifted the tear.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She held her fingertip over the baby’s clean, warm forehead. Slowly, carefully, she wrote directly on the child’s flesh a word that would be invisible. But this word would have power over the child, and later the woman she would become. It would teach her, shape her. Its letters, seven of them, gleamed in the candlelight.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Someday.")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She whispered this into the baby’s ear:")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Someday, everyone you love will die. Everything you love will crumble to ruin. This is the price of life. This is the price of love. It is the only ending for every true story.")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The letters sank into the infant’s dusky skin and vanished as if they’d never been there at all.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Death put the baby down, removed her other glove, and left the pair of them on the floor, where they would be discovered by the baby’s grandmother and mistaken for something else. The gloves would be the only things she would give the girl, though there was much she had taken already, and more she would take in the years to come.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceOrnament"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/orn.jpg",
      "width": "80%"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("For the next seventeen years, Love and Death watched their players. Watched and waited for the Game to begin.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79e42a38","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9780545755863_ch001.vue
// module id = 69
// module chunks = 0